import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">最新黑料速递</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日精选最劲爆的娱乐八卦内容，吃瓜不停歇
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {cardsData.map((card) => (
            <article key={card.id} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden bg-foreground-900">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded text-[10px] font-bold bg-primary-500 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded text-[10px] font-medium bg-foreground-900/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{card.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500 text-xs"></i>
                    {card.heat}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}